module.exports = __webpack_public_path__ + "img/5dd3109.jpg";